<template>
  <svg id="glasses" width="200" height="200">
    <path class="hair" fill="none" stroke="#2D2D2D" stroke-width="2"
          d="M 105,70
            C 105,70 30,70 30,170
            L 30,180
            C 30,180 30,280 105,280
            L 105,300 -5,300 -5,-5 210,-5
            C 210,-5 190,20 180,30
            C 180,30 130,70 105,70"/>
    <path class="face" fill="none" stroke="#2D2D2D" stroke-width="2"
          d="M 105,-5 L 105,205"/>
    <path class="ear" fill="none" stroke="#2D2D2D" stroke-width="2"
          d="M 105,70
            C 105,70 30,70 30,170
            L 30,180
            C 30,180 30,280 105,280
            L 105,70"/>
    <g class="lens-group">
      <path class="lens" fill="none" stroke="#2D2D2D" stroke-width="2"
          d="M 250,40 85,40 85,185
            C 85,185 85,235, 120,235
            L 250,235 250,40"/>
      <path class="strike" fill="none" stroke="#2D2D2D" stroke-width="2"
            d="M 220,40
              L 160,130 190,130 130,235 150,235 220,115 190,115 240,40 220,40"/>
    </g>
    <path class="frame" fill="none" stroke="#2D2D2D" stroke-width="2"
          d="M 205,30
            L 40,30 40,50 70,50 70,80 90,80 90,65
            C 90,65 90,50 110,50
            L 205,50"/>
    <path class="gold-frame" fill="none" stroke="#2D2D2D" stroke-width="2"
          d="M 75,80 L 75,185
            C 75,185 76,240 110,240
            L 205,240 205,230 110,230
            C 110,230 85,230 85,185
            L 85,80 75,80"/>
  </svg>
</template>

<script>
export default {
  name: 'GlassesSvg'
}
</script>

<style scoped>
body {
  text-align: center;
}

#glasses {
  border: 2px solid #2D2D2D;
  background: #FFF;
}

.frame {
  fill: #888;
}

.hair {
  fill: #2D2D2D;
}

.gold-frame {
  fill: #F2BF5C;
}

.lens-group {
  opacity: 1;
  transition: opacity 300ms ease;
}

.lens-group:hover {
  opacity: 0.5;
  transition: opacity 300ms ease;
}

.lens-group:hover .strike {
  opacity: 0;
  transition: opacity 300ms ease;
}

.lens {
  fill: #2D2D2D;
  fill-opacity: 0.8;
}

.strike {
  fill: #FFF;
  fill-opacity: 0.8;
}
</style>

